import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NbMenuItem } from '@nebular/theme';
import { Routes, RouterModule } from '@angular/router';
import { UbsViewContainersModule, ViewContainersService } from '@urbannex/view-containers';
import { ConfigurationsComponent } from './configurations.component';

export const configroutes: Routes = [
  {
    path:'',
    component:ConfigurationsComponent,
    children:[
    {
      path:'configuration/:configUtemId',
      component:ConfigurationsComponent,
      
    },
    {
      path:'configuration/:configUtemId/config-options',
      component:ConfigurationsComponent
    },
    {
      path:'configuration/:configUtemId/content',
      component:ConfigurationsComponent
    },
    {
      path:'configuration/:configUtemId/products',
      component:ConfigurationsComponent
    }

    ]
  }
]

const MENU_ITEMS:NbMenuItem[] = [];
const headerTitle:string = "Configuration";
const path:string = "configurations";
const menuTag:string = "configurationsMenu"


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(configroutes),
    UbsViewContainersModule
  ]
})
export class ConfigurationRoutingModule { 
  menuAndTitleOptions = {path:path,menuItems:MENU_ITEMS,headerTitle:headerTitle,menuTag:menuTag};
  constructor(private viewContainerService:ViewContainersService){
    this.viewContainerService.menuAndTitleOptions$.next([... this.viewContainerService.menuAndTitleOptions$.getValue(),this.menuAndTitleOptions]);
    this.viewContainerService.activeMenuTag$.next(menuTag);
    //this.viewContainerService.addMenuAndTitleOptions(menuAndTitleOptions)
  }
}
